function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DEFAULT_COLORS, SECTION_LINE_WIDTH, COLOR_TRANSPARENT, SECTION_HOVERED_LINE_WIDTH, SECTION_SELECTED_LINE_WIDTH, ROW_LINE_WIDTH, ROW_HOVERED_LINE_WIDTH, ROW_SELECTED_LINE_WIDTH, HIGHLIGHTED_LINE_WIDTH, COLOR_TEXT_SHADOW, SOURCE_ID, SOURCE_LAYER } from '../../constants';
export function compileStyle(tileSource, glyphSource, sectionData, sectionsMetadata, internalOptions, options) {
  var _style$layers;
  var baseSource;
  if (typeof tileSource === 'string' && tileSource.toLowerCase().endsWith('.pbf')) {
    baseSource = {
      type: 'vector',
      tiles: [tileSource]
    };
  } else {
    baseSource = {
      type: 'geojson',
      data: tileSource
    };
  }
  var stageLayers = (internalOptions === null || internalOptions === void 0 ? void 0 : internalOptions.stageLayers) || [];
  var rowZoom = (internalOptions === null || internalOptions === void 0 ? void 0 : internalOptions.rowZoom) || 22;
  var colors = _objectSpread(_objectSpread({}, DEFAULT_COLORS), options && options.colors || {});
  var rowColorMap = {};
  var sectionLayers = [];
  var sectionColorMap = {};
  sectionData === null || sectionData === void 0 || sectionData.forEach(function (section) {
    if (section.color) {
      var sectionMetaData = sectionsMetadata === null || sectionsMetadata === void 0 ? void 0 : sectionsMetadata.sections[section.mbi];
      var featureFilter = [];
      sectionMetaData === null || sectionMetaData === void 0 || sectionMetaData.featureIds.forEach(function (featureId) {
        featureFilter.push(['==', ['id'], featureId]);
      });
      var rowFilter = [];
      section.rows.forEach(function (row) {
        rowFilter.push(['==', 'id', "".concat(section.mbi, ":").concat(row)]);
      });
      var colorRows = rowColorMap[section.color];
      var colorSections = sectionColorMap[section.color];
      if (colorRows) {
        colorRows.push.apply(colorRows, rowFilter);
        colorSections.push.apply(colorSections, featureFilter);
      } else {
        rowColorMap[section.color] = [].concat(rowFilter);
        sectionColorMap[section.color] = [].concat(featureFilter);
      }
    }
  });
  var rowFill = [];
  Object.keys(rowColorMap).forEach(function (color) {
    rowFill.push({
      id: "row-".concat(color),
      type: 'fill',
      source: SOURCE_ID,
      minzoom: 0,
      filter: ['any'].concat(_toConsumableArray(rowColorMap[color])),
      paint: {
        'fill-color': ['case', ['boolean', ['feature-state', 'selected'], false], colors['row-selected-fill'], ['boolean', ['feature-state', 'hovered'], false], colors['row-hovered-fill'], ['boolean', ['feature-state', 'highlighted'], false], colors['row-selected-fill'], ['boolean', ['feature-state', 'available'], false], color, colors['seating-disabled-fill']]
      }
    });
    var sectionOverride = {
      id: "section-fill-".concat(color),
      type: 'fill',
      source: SOURCE_ID,
      maxzoom: rowZoom,
      filter: ['any'].concat(_toConsumableArray(sectionColorMap[color])),
      paint: {
        'fill-color': ['case', ['boolean', ['feature-state', 'selected'], false], colors['section-selected-fill'], ['boolean', ['feature-state', 'hovered'], false], colors['section-hovered-fill'], ['boolean', ['feature-state', 'highlighted'], false], colors['section-selected-fill'], ['boolean', ['feature-state', 'available'], false], color, colors['seating-disabled-fill']]
      }
    };
    sectionLayers.push(sectionOverride);
  });
  var style = {
    version: 8,
    name: 'base',
    glyphs: glyphSource,
    sources: _defineProperty({}, SOURCE_ID, baseSource),
    layers: [{
      id: 'background',
      type: 'background',
      paint: {
        'background-color': colors.background
      }
    }, {
      id: 'venue',
      type: 'fill',
      source: SOURCE_ID,
      filter: ['==', 'c', 'stadium'],
      paint: {
        'fill-color': colors['venue-fill']
      }
    }, {
      id: 'venue-outline',
      type: 'line',
      source: SOURCE_ID,
      filter: ['==', 'c', 'stadium'],
      paint: {
        'line-color': colors['venue-stroke'],
        'line-width': 1.5
      }
    }, {
      id: 'section-backdrop',
      type: 'fill',
      source: SOURCE_ID,
      minzoom: rowZoom,
      filter: ['==', 't', 's'],
      paint: {
        'fill-color': colors['seating-disabled-fill']
      }
    }, {
      id: 'section',
      type: 'fill',
      source: SOURCE_ID,
      maxzoom: rowZoom,
      filter: ['==', 't', 's'],
      paint: {
        'fill-color': ['case', ['boolean', ['feature-state', 'selected'], false], colors['section-selected-fill'], ['boolean', ['feature-state', 'hovered'], false], colors['section-hovered-fill'], ['boolean', ['feature-state', 'available'], false], colors['section-available-fill'], colors['seating-disabled-fill']]
      }
    }, {
      id: 'section-outline',
      type: 'line',
      source: SOURCE_ID,
      filter: ['==', 't', 's'],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': colors['seating-disabled-stroke'],
        'line-width': SECTION_LINE_WIDTH
      }
    }, {
      id: 'section-outline--available',
      type: 'line',
      source: SOURCE_ID,
      filter: ['==', 't', 's'],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': ['case', ['boolean', ['feature-state', 'highlighted'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'selected'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'hovered'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'available'], false], COLOR_TRANSPARENT, COLOR_TRANSPARENT],
        'line-width': SECTION_LINE_WIDTH
      }
    }, {
      id: 'section-outline--hovered',
      type: 'line',
      source: SOURCE_ID,
      filter: ['==', 't', 's'],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': ['case', ['boolean', ['feature-state', 'highlighted'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'selected'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'hovered'], false], colors['section-selected-stroke'], COLOR_TRANSPARENT],
        'line-width': SECTION_HOVERED_LINE_WIDTH
      }
    }, {
      id: 'section-outline--selected',
      type: 'line',
      source: SOURCE_ID,
      filter: ['==', 't', 's'],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': ['case', ['boolean', ['feature-state', 'highlighted'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'selected'], false], colors['section-selected-stroke'], COLOR_TRANSPARENT],
        'line-width': SECTION_SELECTED_LINE_WIDTH
      }
    }, {
      id: 'row',
      type: 'fill',
      source: SOURCE_ID,
      minzoom: rowZoom,
      filter: ['==', 't', 'r'],
      paint: {
        'fill-color': ['case', ['boolean', ['feature-state', 'selected'], false], colors['row-selected-fill'], ['boolean', ['feature-state', 'hovered'], false], colors['row-hovered-fill'], ['boolean', ['feature-state', 'available'], false], colors['row-available-fill'], colors['seating-disabled-fill']]
      }
    }].concat(rowFill, sectionLayers, [{
      id: 'row-outline',
      type: 'line',
      source: SOURCE_ID,
      minzoom: rowZoom,
      filter: ['==', 't', 'r'],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': colors['seating-disabled-stroke'],
        'line-width': ROW_LINE_WIDTH
      }
    }, {
      id: 'row-outline--available',
      type: 'line',
      source: SOURCE_ID,
      minzoom: rowZoom,
      filter: ['==', 't', 'r'],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': ['case', ['boolean', ['feature-state', 'highlighted'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'selected'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'hovered'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'available'], false], colors['row-available-stroke'], COLOR_TRANSPARENT],
        'line-width': ROW_LINE_WIDTH
      }
    }, {
      id: 'row-outline--hovered',
      type: 'line',
      source: SOURCE_ID,
      minzoom: rowZoom,
      filter: ['==', 't', 'r'],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': ['case', ['boolean', ['feature-state', 'highlighted'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'selected'], false], COLOR_TRANSPARENT, ['boolean', ['feature-state', 'hovered'], false], colors['row-hovered-stroke'], COLOR_TRANSPARENT],
        'line-width': ROW_HOVERED_LINE_WIDTH
      }
    }, {
      id: 'row-outline--selected',
      type: 'line',
      source: SOURCE_ID,
      minzoom: 0,
      filter: ['==', 't', 'r'],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': ['case', ['boolean', ['feature-state', 'selected'], false], colors['row-selected-stroke'], COLOR_TRANSPARENT],
        'line-width': ROW_SELECTED_LINE_WIDTH
      }
    }, {
      id: 'highlight',
      type: 'line',
      source: SOURCE_ID,
      filter: ['in', 't', 's'],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': ['case', ['boolean', ['feature-state', 'highlighted'], false], colors['highlighted-stroke'], COLOR_TRANSPARENT],
        'line-width': HIGHLIGHTED_LINE_WIDTH
      }
    }], _toConsumableArray(stageLayers), [{
      id: 'label',
      type: 'symbol',
      source: SOURCE_ID,
      filter: ['all', ['==', '$type', 'Point'], ['==', 't', 'l']],
      layout: {
        'text-field': '{l}',
        'text-font': ['roboto-bold'],
        'text-max-width': 14,
        'text-size': {
          base: 1,
          stops: [[0, 0], [6, 3], [9, 14], [12, 36]]
        },
        'text-line-height': 1.1,
        'text-padding': 3,
        'text-allow-overlap': true,
        'text-ignore-placement': true
      },
      paint: {
        'text-color': colors.label
      }
    }, {
      id: 'row-label',
      type: 'symbol',
      source: SOURCE_ID,
      minzoom: rowZoom,
      filter: ['all', ['==', '$type', 'Point'], ['==', 't', 'rl']],
      layout: {
        'text-field': '{l}',
        'text-font': ['roboto-medium'],
        'text-transform': 'uppercase',
        'text-size': {
          base: 1,
          stops: [[0, 0], [9, 4], [18, 32]]
        },
        'text-allow-overlap': true,
        'text-ignore-placement': false
      },
      paint: {
        'text-color': colors['row-label'],
        'text-halo-width': 1,
        'text-halo-color': COLOR_TEXT_SHADOW,
        'text-opacity': {
          base: 1,
          stops: [[8.5, 0], [9, 1]]
        }
      }
    }, {
      id: 'section-label',
      type: 'symbol',
      source: SOURCE_ID,
      filter: ['all', ['==', '$type', 'Point'], ['==', 't', 'sl'], ['!has', 'c']],
      layout: {
        'text-padding': 3,
        'text-field': '{l}',
        'text-font': ['roboto-bold'],
        'text-line-height': 1.1,
        'text-transform': 'uppercase',
        'text-size': {
          base: 1,
          stops: [[0, 0], [6, 3], [9, 14], [12, 36]]
        },
        'text-allow-overlap': true,
        'text-ignore-placement': true
      },
      paint: {
        'text-color': colors['section-label'],
        'text-halo-width': 1,
        'text-halo-color': COLOR_TEXT_SHADOW,
        'text-opacity': {
          base: 1,
          stops: [[9, 1], [9.25, 0.6]]
        }
      }
    }, {
      id: 'section-label_collision',
      type: 'symbol',
      source: SOURCE_ID,
      filter: ['all', ['==', '$type', 'Point'], ['==', 't', 'sl'], ['==', 'c', 'section-collision-labels']],
      layout: {
        'text-padding': 3,
        'text-field': '{l}',
        'text-font': ['roboto-bold'],
        'text-line-height': 1.1,
        'text-transform': 'uppercase',
        'text-size': {
          base: 1,
          stops: [[0, 0], [6, 3], [9, 14], [12, 36]]
        },
        'text-allow-overlap': false,
        'text-ignore-placement': false
      },
      paint: {
        'text-color': colors['section-label'],
        'text-halo-width': 1,
        'text-halo-color': COLOR_TEXT_SHADOW,
        'text-opacity': {
          base: 1,
          stops: [[9, 1], [9.25, 0.6]]
        }
      }
    }])
  };
  style === null || style === void 0 || (_style$layers = style.layers) === null || _style$layers === void 0 || _style$layers.forEach(function (layer) {
    layer.source = SOURCE_ID;
    if (baseSource.type === 'vector') {
      layer['source-layer'] = SOURCE_LAYER;
    }
  });
  return style;
}